import i18n from '../i18n';

class SubscriptionPresenter {
  constructor(subscription) {
    this.subscription = subscription;
  }

  getPlanName() {
    return this.subscription?.plan_name;
  }

  getPlanDisplayName() {
    const planName = this.getPlanName();
    if (!planName) return undefined;
    
    return i18n.t(`subscription.plans.${planName}`);
  }

  getBillingPeriod() {
    return this.subscription?.billing_period || 'monthly';
  }

  getStatus() {
    if (this.hasPendingCancellation()) {
      return 'pending_cancellation';
    }
    return this.subscription?.status || 'active';
  }

  getNextBillingDate() {
    return this.subscription?.next_billing_date;
  }

  hasSubscription() {
    const planName = this.getPlanName();
    return planName && planName !== 'free';
  }

  hasSubscriptionProblem() {
    return this.subscription?.status === 'past_due';
  }

  hasPendingCancellation() {
    return this.subscription?.cancel_at_period_end;
  }

  getPendingCancellationDate() {
    return this.subscription?.cancel_effective_date;
  }

  getPendingPlanName() {
    return this.subscription?.pending_plan_name;
  }

  getPendingPlanDisplayName() {
    const pendingPlanName = this.getPendingPlanName();
    if (!pendingPlanName) return undefined;
    
    return i18n.t(`subscription.plans.${pendingPlanName}`);
  }

  getPendingPlanEffectiveDate() {
    return this.subscription?.pending_plan_effective_date;
  }
}

export default SubscriptionPresenter; 